import React from 'react';
import Habitos from '../components/Habitos';

const HabitosPage: React.FC = () => {
    return <Habitos />;
};

export default HabitosPage;
